<template>
  <div id="app">
    <router-view />

  </div>
</template>

<script>
import store from '@/store'

export default {
  name: 'App',
  data() {
    return {
      timer: null
    }
  },
  mounted() {
    const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    if (flag) {
      new window.VConsole()
    }

  },
  methods: {


  }
}
</script>
